import { normalizeSymbolCode } from './marketThumb';

/** 玩法 → 下單頁路由 */
export const PLAY_TYPE_TRADE_PATH = {
  TIME_LIMITED: '/trade/timed',
  FUTURES: '/trade/futures',
  PERPETUAL: '/trade/perpetual',
};

const TAB_KEY_BY_PLAY_TYPE = {
  TIME_LIMITED: 'timed',
  FUTURES: 'delivery',
  PERPETUAL: 'perpetual',
};

/** 依玩法與交易對組下單頁路徑 */
export function buildTradePath(playType, marketSymbolCode) {
  const base = PLAY_TYPE_TRADE_PATH[playType] || PLAY_TYPE_TRADE_PATH.FUTURES;
  const symbol = normalizeSymbolCode(marketSymbolCode);
  if (!symbol) {
    return base;
  }
  return `${base}?symbol=${encodeURIComponent(symbol)}`;
}

export function playTypeToTabKey(playType) {
  return TAB_KEY_BY_PLAY_TYPE[playType] || 'delivery';
}
